import { render } from "./AppDivision.vue?vue&type=template&id=0e06a7ed"
import script from "./AppDivision.vue?vue&type=script&lang=js"
export * from "./AppDivision.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__